(function ( $ ) {

	$.fn.tabs = function () {
		var $elem = $( this ),
			parent = $elem.parent(),
			$tabsSections = $elem.find( '.tabs__containers' ).find( '.tab__section' ),
			$tabHeadersContainer = $elem.find( '.tabs__headers__list' ),
			$tabHeaders = $tabHeadersContainer.find( '.tab__header' ),
			$tabTogglers = $tabHeaders.find( '.tab__toggler' ),
			tabMode = 'vertical' == $elem.data( 'tab-mode' ) ? 'vertical' : 'horizontal';

		var init = function () {

				$tabsSections.not( ':eq(0)' ).hide();
				$tabTogglers.eq( 0 ).addClass( 'active' );

				ariaSetup();
				bindEvents();

			},
			ariaSetup = function () {
				// Taken from http://heydonworks.com/practical_aria_examples/js/a11y.js

				$tabHeadersContainer.attr( 'role', 'tablist' );

				$tabHeaders.attr( 'role', 'presentation' );

				$tabTogglers.attr( {
					'role'     : 'tab',
					'tabindex' : '-1'
				} );

				$tabTogglers.each( function () {
					$( this ).attr(
						'aria-controls', $( this ).attr( 'href' ).substring( 1 )
					);
				} );

				$tabTogglers.eq( 0 ).attr( {
					'aria-selected' : 'true',
					'tabindex'      : '0'
				} );


				$tabsSections.attr( {
					'role' : 'tabpanel'
				} );

				$tabsSections.find( '> *:first-child' ).attr( {
					'tabindex' : '0'
				} );

				$tabsSections.not( ':eq(0)' ).attr( {
					'aria-hidden' : 'true'
				} );

			},
			bindEvents = function () {
				$tabTogglers.on( 'click', function ( e ) {
					e.preventDefault();

					toggleTab( $( this ) );
				} );
			},
			toggleTab = function ( $tabToggler ) {

				var matchingContainerData = $tabToggler.attr( 'href' ),
					$matchingContainer = $tabsSections.filter( matchingContainerData );


				$tabsSections.not( $matchingContainer )
					.removeClass( 'active' )
					.slideUp( 'fast' )
					.attr( 'aria-hidden', 'true' );

				if ( $tabsSections.hasClass( 'active' ) ) {
					// we re-clicked on an active tab : do nothing, don't collect $200
				} else {
					$matchingContainer.slideDown()
						.addClass( 'active' )
						.attr( 'aria-hidden', null );

					// All others
					$tabTogglers.not( $tabToggler )
						.removeClass( 'active' )
						.attr( {
							'tabindex'      : '-1',
							'aria-selected' : null
						} );


					$tabToggler
						.addClass( 'active' )
						.attr( {
							'tabindex'      : '0',
							'aria-selected' : true
						} ).focus();
				}
			};


		init();
		return this;
	};

}( jQuery ));
